import { SEO_ESTABLISHMENT_CARD_CLICK_SECTIONS, SEO_ESTABLISHMENT_CARD_CLICK_SUBSECTIONS } from 'molecules/seo-establishment-card/index';
import { PropTypes } from 'prop-types';
import React from 'react';
import Title from 'atoms/title';


export default function Body({ establishmentTitle, establishmentType, guests, area, city, titlePreposition, comments, hasPrice, clickinHref, handleOnClick, rating, isFollow, t }) {
  const establishmentTypes = {
    1: t('Apartment'),
    2: t('Hotel'),
    3: t('House'),
    4: t('Room'),
  };

  return (
    <div className="ak-establishment-card__body">
      <h3 className="ak-establishment-card__body__title">
        <a
          className="ak-establishment-card__body__title__link"
          href={ clickinHref }
          onClick={ handleOnClick.bind(null, SEO_ESTABLISHMENT_CARD_CLICK_SECTIONS.SEO, SEO_ESTABLISHMENT_CARD_CLICK_SUBSECTIONS.TITLE) }
          rel={ isFollow ? '' : 'nofollow' }
          target="_blank"
        >
          <Title
            area={ area || '' }
            city={ city || '' }
            t={ t }
            text={ establishmentTitle }
            titlePreposition={ titlePreposition || '' }
            type={ establishmentType }
          />
        </a>
      </h3>
      <div className="ak-establishment-card__body__container">
        <div className="ak-establishment-card__body__type">
          { t('Establishment type: {establishmentType}', { establishmentType: establishmentTypes[establishmentType] }) }
        </div>
        <div className="ak-establishment-card__body__people-area">
          <span className="ak-establishment-card__body__people-area__people">
            { guests === 1 ? t('{guests} guest', { guests }) : t('{guests} guests', { guests }) }
          </span>
          { area
            && (
              <span>
                <span className="ak-establishment-card__body__people-area__separator">
                  { " | " }
                </span>
                <span className="ak-establishment-card__body__people-area__area">
                  { t('{area} m²', { area }) }
                </span>
              </span>
            )
          }
        </div>
        { rating
          && (
            <div className="ak-establishment-card__body__rating-partner">
              <span className="ak-establishment-card__body__rating-partner__rating">
                { t('Rating: {rating}', { rating }) }
              </span>
            </div>
          )
        }
        <div className="ak-establishment-card__body__com-cta">
          <span className="ak-establishment-card__body__com-cta__com">
            {t('Comments: {comments}', { comments: comments || Math.floor(Math.random() * (6)) + 4 }) }
          </span>
          <span className="ak-establishment-card__body__com-cta__cta">
            <span className="ak-establishment-card__body__com-cta__cta__text">
              <a
                href={ clickinHref }
                onClick={ handleOnClick.bind(null, SEO_ESTABLISHMENT_CARD_CLICK_SECTIONS.SEO, SEO_ESTABLISHMENT_CARD_CLICK_SUBSECTIONS.CTA) }
                rel={ isFollow ? '' : 'nofollow' }
                target="_blank"
              >
                { hasPrice ? t('View offer') : t('View more') }
              </a>
            </span>
            <span className="ak-establishment-card__body__com-cta__cta__icon hundredicons-arrow-right-filled" />
          </span>
        </div>
      </div>
    </div>
  );
}

Body.defaultProps = {
  area: null,
  city: null,
  hasPrice: null,
  rating: null,
  titlePreposition: null,
};

Body.propTypes = {
  area: PropTypes.number,
  city: PropTypes.string,
  clickinHref: PropTypes.string.isRequired,
  comments: PropTypes.number.isRequired,
  establishmentTitle: PropTypes.string.isRequired,
  establishmentType: PropTypes.number.isRequired,
  guests: PropTypes.number.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  hasPrice: PropTypes.bool,
  isFollow: PropTypes.bool.isRequired,
  rating: PropTypes.number,
  t: PropTypes.func.isRequired,
  titlePreposition: PropTypes.string,
};
